import React from "react";

import type { TokenInfo, TokenInstance } from "types/api/token";
import type { TokenTransfer } from "types/api/tokenTransfer";

import { AddressHighlightProvider } from "lib/contexts/addressHighlight";
import { NFT_TOKEN_TYPE_IDS } from "lib/token/tokenTypes";
import {
  TableBody,
  TableColumnHeader,
  TableHeaderSticky,
  TableRoot,
  TableRow,
} from "toolkit/chakra/table";
import * as SocketNewItemsNotice from "ui/shared/SocketNewItemsNotice";
import TimeFormatToggle from "ui/shared/time/TimeFormatToggle";
import TruncatedValue from "ui/shared/TruncatedValue";
import { getTokenDisplaySymbol } from "ui/shared/entities/token/TokenEntity";
import TokenTransferTableItem from "ui/token/TokenTransfer/TokenTransferTableItem";

interface Props {
  data: Array<TokenTransfer>;
  top: number;
  showSocketInfo: boolean;
  showSocketErrorAlert?: boolean;
  socketInfoNum?: number;
  tokenId?: string;
  isLoading?: boolean;
  token: TokenInfo;
  instance?: TokenInstance;
}

const TokenTransferTable = ({
  data,
  top,
  showSocketInfo,
  showSocketErrorAlert,
  socketInfoNum,
  tokenId,
  isLoading,
  token,
  instance,
}: Props) => {
  const tokenType = token.type;
  console.log("TokenTransferTable token", token);
  return (
    <AddressHighlightProvider>
      <TableRoot minW="950px">
        <TableHeaderSticky top={top}>
          <TableRow>
            <TableColumnHeader width="280px">
              Txn hash
              <TimeFormatToggle />
            </TableColumnHeader>
            <TableColumnHeader width="200px">Method</TableColumnHeader>
            <TableColumnHeader width={{ lg: "224px", xl: "380px" }}>
              From/To
            </TableColumnHeader>
            {NFT_TOKEN_TYPE_IDS.includes(tokenType) && (
              <TableColumnHeader
                width={
                  tokenType === "ERC-1155" || tokenType === "ERC-404"
                    ? "50%"
                    : "100%"
                }
              >
                Token ID
              </TableColumnHeader>
            )}
            {(tokenType === "ERC-20" ||
              tokenType === "ERC-1155" ||
              tokenType === "ERC-404") && (
              <TableColumnHeader
                width={tokenType === "ERC-20" ? "100%" : "50%"}
                isNumeric
              >
                <TruncatedValue
                  value={`Value ${getTokenDisplaySymbol(token?.address || token?.address_hash, token?.symbol)}`}
                  w="100%"
                  verticalAlign="middle"
                />
              </TableColumnHeader>
            )}
          </TableRow>
        </TableHeaderSticky>
        <TableBody>
          {showSocketInfo && (
            <SocketNewItemsNotice.Desktop
              showErrorAlert={showSocketErrorAlert}
              num={socketInfoNum}
              type="token_transfer"
              isLoading={isLoading}
            />
          )}
          {data.map((item, index) => (
            <TokenTransferTableItem
              key={
                item.transaction_hash +
                item.block_hash +
                item.log_index +
                "_" +
                index
              }
              {...item}
              tokenId={tokenId}
              instance={instance}
              isLoading={isLoading}
            />
          ))}
        </TableBody>
      </TableRoot>
    </AddressHighlightProvider>
  );
};

export default React.memo(TokenTransferTable);
